import { theme, toRem } from '../../styles';
import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
  text-align: right;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
  font-size: ${toRem(13)};
  font-weight: ${theme.fonts['fontWeightMedium']};
  line-height: 100%;
  padding: ${toRem(10)};
  padding-left: ${toRem(14)};
  margin-left: ${toRem(10)};
  background-color: transparent;
  color: ${theme.colors['base-10']};
  cursor: pointer;
  span {
    font-size: ${toRem(20)};
    font-weight: ${theme.fonts['fontWeightRegular']};
  }
  &:focus-visible {
    outline: 2px solid;
  }
`;

export const DropdownList = styled.ul`
  display: flex;
  padding: ${toRem(24)};
  flex-direction: column;
  align-items: flex-start;
  gap: ${toRem(16)};
  position: absolute;
  right: 0;
  min-width: ${toRem(200)};
  background-color: ${theme.colors.white};
  border-radius: ${toRem(14)};
  list-style: none;
  overflow-y: auto;
  box-shadow: 0 0 ${toRem(8)} ${toRem(6)} rgba(0, 0, 0, 0.1);
  z-index: 100;

  @media ${theme.mediaQuery.mobileOnly} {
    position: static;
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.background};
    box-shadow: none;
    border-radius: unset;
  }
`;

export const DropdownLabel = styled.li`
  color: ${theme.colors['light-gray-10']};
  font-size: ${toRem(12)};
  font-weight: ${theme.fonts['fontWeightMedium']};
  line-height: ${toRem(12)};
  letter-spacing: ${toRem(1.2)};
  cursor: pointer;
`;
